import Image from "next/image";
import React from "react";
import { Button } from "../ui/button";

interface LocationCardProps {
  location: React.ReactNode;
  address: React.ReactNode;
  phone: React.ReactNode;
  mapLink: string;
  // latitude: string;
  // longitude: string;
  setCurrentMapLink: (link: string) => void;
}

export default function LocationCard({
  location,
  address,
  phone,
  mapLink,
  // latitude,
  // longitude,
  setCurrentMapLink,
}: LocationCardProps) {
  const handleViewOnMap = () => {
    setCurrentMapLink(mapLink);
  };

  return (
    <div className="flex flex-col rounded-mob-10 sm:rounded-tab-10 lg:rounded-web-10 justify-between px-mob-30 sm:px-tab-30 lg:px-web-30 py-mob-22 sm:py-tab-22 lg:py-web-22 bg-[#F5F5F5] w-[90.69vw] sm:w-[calc(50%-2.8vw)] lg:w-[17.18vw] h-auto ">
      <div className="flex flex-col mb-2 gap-4 lg:gap-6">
        <h3 className="text-mob-28 sm:text-tab-28 lg:text-web-28">
          {location}
        </h3>

        <div className="flex items-start gap-2.5">
          <div className="relative min-w-max w-mob-24 sm:w-tab-24 lg:w-web-24">
            <Image
              src="/images/location.svg"
              alt="location"
              fill
              className="!static"
            />
          </div>
          <p className="text-mob-16 sm:text-tab-17 lg:text-web-18 text-ParaLight">
            {address}
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-4 lg:gap-6">
        <div className="flex items-start gap-2.5">
          <div className="relative w-mob-24 sm:w-tab-24 lg:w-web-24">
            <Image
              src="/images/call-icon.svg"
              alt="call"
              fill
              className="!static"
            />
          </div>
          <p className="text-mob-18 sm:text-tab-18 lg:text-web-18 text-ParaLight">
            {phone}
          </p>
        </div>

        <Button
          onClick={handleViewOnMap}
          variant={"secondaryLinkBtnBlue"}
          className="ml-0"
        >
          View on map
          <div className="relative ml-0.5">
            <Image
              src="/images/chevron-right-blue.svg"
              alt="arrow"
              fill
              className="!static"
            />
          </div>
        </Button>
      </div>
    </div>
  );
}
